var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 45,
    viewBox: "0 0 71 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "8r0y8xd48a",
    d: "M0 0h2.623v2.623H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qer4lnrw2c",
    d: "M0 0h2.623v2.623H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xbll08svpe",
    d: "M0 0h2.623v2.623H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5i83gtgi3g",
    d: "M0 0h2.623v2.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "76opos4a2i",
    d: "M0 0h2.623v2.623H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs5ge3dkrk",
    d: "M0 0h2.623v2.623H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i4f1b814rm",
    d: "M0 0h2.623v2.623H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "oq9qbb0a7o",
    d: "M0 0h2.623v2.622H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 41.607)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t680pxn6pb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8r0y8xd48a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.623 1.311a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0",
    fill: "#FFF",
    mask: "url(#t680pxn6pb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.894 42.918a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0M25.165 42.918a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0M36.436 42.918a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0M1.311 0a1.311 1.311 0 1 1 0 2.623A1.311 1.311 0 0 1 1.31 0M12.582 0a1.311 1.311 0 1 1 0 2.623 1.311 1.311 0 0 1 0-2.623M23.854 0a1.311 1.311 0 1 1-.001 2.623 1.311 1.311 0 0 1 0-2.623M35.125 0a1.311 1.311 0 1 1 0 2.623 1.311 1.311 0 0 1 0-2.623",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.688)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r0jf4o1ied",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qer4lnrw2c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.623 1.312a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0",
    fill: "#FFF",
    mask: "url(#r0jf4o1ied)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.894 12a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0M25.165 12a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0M36.436 12a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 21.378)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ddawtp8khf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xbll08svpe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.623 1.311a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0",
    fill: "#FFF",
    mask: "url(#ddawtp8khf)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.894 22.69a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0M25.165 22.69a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0M36.436 22.69a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.068)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ve7olg9b5h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5i83gtgi3g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.623 1.311a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0",
    fill: "#FFF",
    mask: "url(#ve7olg9b5h)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.894 33.379a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0M25.165 33.379a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0M36.436 33.379a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0M36.436 42.918a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0M47.707 42.918a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0M58.978 42.918a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.626 41.607)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m0i0pigx0j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#76opos4a2i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.623 1.311a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0",
    fill: "#FFF",
    mask: "url(#m0i0pigx0j)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.125 0a1.311 1.311 0 1 1 0 2.623 1.311 1.311 0 0 1 0-2.623M46.396 0a1.312 1.312 0 1 1 0 2.624 1.312 1.312 0 0 1 0-2.624M57.667 0a1.311 1.311 0 1 1 0 2.623 1.311 1.311 0 0 1 0-2.623M68.938 0a1.311 1.311 0 1 1 0 2.623 1.311 1.311 0 0 1 0-2.623M36.436 12a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0M47.707 12a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0M58.978 12a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.626 10.688)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l6b6czwnol",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bs5ge3dkrk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.623 1.312a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0",
    fill: "#FFF",
    mask: "url(#l6b6czwnol)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.436 22.69a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0M47.707 22.69a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0M58.978 22.69a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.626 21.378)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s5usr6c2bn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i4f1b814rm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.623 1.311a1.312 1.312 0 1 1-2.624 0 1.312 1.312 0 0 1 2.624 0",
    fill: "#FFF",
    mask: "url(#s5usr6c2bn)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.436 33.379a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0M47.707 33.379a1.311 1.311 0 1 1-2.622-.001 1.311 1.311 0 0 1 2.622 0M58.978 33.379a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.626 32.068)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w4zc3fdorp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oq9qbb0a7o"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.623 1.311a1.311 1.311 0 1 1-2.622 0 1.311 1.311 0 0 1 2.622 0",
    fill: "#FFF",
    mask: "url(#w4zc3fdorp)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.5c3aaf325993dee41f0cd70c0e7c09b8.svg";
export { ForwardRef as ReactComponent };